import * as React from 'react'
import { fromJSX } from 'widgets-for-react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { DP } from '../../../drupal/blockDefinitions'
import { dummyData, randomCaption, randomTitle, randomWords } from '../../../utils/dummyData'
import { linkWrapper } from '../../../utils/link'
import { ModernBlock, SeoEvent } from '../../modernBlocks.state'
import { downloadBlockClasses, DownloadBlockLayout } from './downloadBlock.layout'
import { DownloadBlockProps, DownloadItem } from './downloadBlock.state'

export const downloadBlock: ModernBlock<DownloadBlockProps, any, any, DP.Download> = {
  kind: 'downloadBlock',
  render: (setRootState, rootState, blockIndex, blockProps, amountNested) =>
    fromJSX((updateBlock) => (
      <DownloadBlockLayout.Inner amountNested={amountNested!}>
        <DownloadBlockLayout.Content
          label={blockProps.label}
          title={blockProps.title}
          intro={blockProps.intro}
          items={blockProps.items}
          showPrimary={blockProps.showPrimary}
          showSecondary={blockProps.showSecondary}
          primaryAction={blockProps.primaryAction!}
          secondaryAction={blockProps.secondaryAction!}
        />
      </DownloadBlockLayout.Inner>
    )),
  blockClassName: getClassNameModern(downloadBlockClasses, 'block', 'mb-6'),
  inView: {
    showAs: 'section',
    threshold: 0.1,
    triggerOnce: true,
    inViewClassName: getClassNameModern(downloadBlockClasses, 'inview', 'inview'),
    updateState: (currentInviewState, currentBlockState) => {
      return {
        ...currentBlockState,
        inviewState: currentInviewState
      }
    }
  },
  adapters: {
    drupal: (dpBlock: DP.Download, blockIndex: number) => {
      const target = dpBlock.target.type[0].target_id
      if (target != 'downloads') return undefined
      return {
        label: dpBlock.target.field_label ? dpBlock.target.field_label[0]?.value : undefined,
        title: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : undefined,
        excludeFromPageMenu: dpBlock.target?.field_exclude_from_page_menu?.[0]?.value,
        intro: dpBlock.target.field_introduction ? dpBlock.target.field_introduction[0]?.value : undefined,
        showPrimary: dpBlock.target?.field_links[0] ? true : false,
        showSecondary: dpBlock.target?.field_links[1] ? true : false,
        primaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.options?.attributes?.id! : '',
        }),
        secondaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.options?.attributes?.id! : '',
        }),
        items: dpBlock.target.field_download_list.map<DownloadItem>((item, i) => ({
          key: `${item.target.field_title[0]?.value}-${i}`,
          title: item.target.field_title[0]?.value ? item.target.field_title[0]?.value : '',
          text: item.target.field_text.length ? item.target.field_text[0]?.value : '',
          fileUrl: item.target.field_download[0]?.target.field_media_file[0]?.target.uri[0]?.url,
          fileName: item.target.field_download[0]?.target.field_media_file[0]?.target.filename[0]?.value
        })),
        anchorTitle: dpBlock.target.field_title[0]?.value,
      }
    }
  },
  seoEvents: (props, blockIndex) =>
    props.items?.map(
      (item, index) =>
        ({
          id: `download-item-${index}`,
          event: 'onClick',
          category: 'downloads',
          label: window.location.pathname,
          action: item.title
        } as SeoEvent)
    ) || [],

  sampleExample: [
    {
      label: randomWords(),
      title: randomTitle(),
      anchorTitle: 'downloads-sample-1',
      intro: dummyData.intro,
      items: [
        {
          key: 'Item 1',
          title: randomTitle(),
          text: randomCaption(),
          fileUrl: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-512x384.jpeg',
          fileName: 'northern-lights-512x384.jpeg'
        },
        {
          key: 'Item 2',
          title: randomTitle(),
          text: randomCaption(),
          fileUrl: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-1024x768.jpeg',
          fileName: 'northern-lights-1024x768.jpeg'
        },
        {
          key: 'Item 3',
          title: randomTitle(),
          fileUrl: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-2048x1536.jpeg',
          fileName: 'northern-lights-2048x1536.jpeg'
        }
      ],
      showPrimary: true,
      showSecondary: true,
      primaryAction: dummyData.primaryButton,
      secondaryAction: dummyData.secondaryButton
    }
  ]
}
